import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentUser } from 'src/models/lmsConfig/queries';
import axios from 'src/workspace/axios';
import { setPerformanceSnapshot, setStatus } from '../slice';
import { fetchUserMetric } from '../thunk';

export const fetchPerformanceSnapshot = createAsyncThunk(
  'performanceSnapshot',
  async ({ params }: { params: any }, { dispatch }) => {
    try {
      dispatch(setStatus({ performance_snapshot: 'loading' }));

      const response = await axios.get(`/v2/snapshot/cards`);

      const cards = response.data?.body?.cards || [];

      const snapshotCardPromises = cards.map((card) => {
        if (card.type === 'metric') {
          const item = card?.items[0];
          return fetchUserMetric({
            goalDefinitionCode: item?.meta_data?.goal_definition_code,
            userId: params?.user_id,
            frequency: item?.meta_data?.frequency,
            extraParams: {
              skip: 0,
              limit: 8,
              from_web2: true,
            },
          })
            .then((data) => ({
              code: item.code,
              data,
              success: true,
              name: item.name,
              card,
            }))
            .catch((error) => ({
              code: item.code,
              card,
              data: null,
              success: false,
              name: item.name,
              error: error.message,
            }));
        }

        return Promise.resolve(() => ({
          code: card?.code,
          success: true,
          card,
        }));
      });

      // Use allSettled to handle individual failures gracefully
      const snapshotCardResults = await Promise.allSettled(
        snapshotCardPromises,
      );

      // Filter out failed metrics and only include successful ones
      const data = snapshotCardResults
        .filter(
          (result) => result.status === 'fulfilled' && result.value.success,
        )
        .map((result) => {
          if (result.status === 'fulfilled') {
            return {
              name: result.value.name,
              code: result.value.code,
              data: result.value.data,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      dispatch(setPerformanceSnapshot(data));
      dispatch(setStatus({ performance_snapshot: 'done' }));
    } catch (error: any) {
      dispatch(setStatus({ performance_snapshot: 'error' }));
    }
  },
);

const onActivate = ({ dispatch }) => {
  const userId = getCurrentUser()?.code;
  dispatch(fetchPerformanceSnapshot({ params: { user_id: userId } }));
};

const onDeactivate = () => {};

export default { onActivate, onDeactivate };
